// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@bg/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridItemStyles.addNotes = linkIconStyleGenerator({
    icon: "Create",
    textSize: "13px",
    iconSize: 14,
    additionalTypographyCss: css`
        line-height: 18px;
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
});

rfqQuoteDetailsProposedDetailsGridItemStyles.removeQuoteLineLink = linkIconStyleGenerator({
    icon: "Delete",
    textSize: "13px",
    iconSize: 14,
    additionalTypographyCss: css`
        line-height: 18px;
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
});
